<!--
Author: jiangli
Date: 2021-03-19
Desc: 分红信息明细
 -->
<template>
    <div :class="'bizcomp-trade-record bizcomp ' + className">
        <comp-title :title="title">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/fund' }">
                    基金交易
                </el-breadcrumb-item>
                <el-breadcrumb-item>{{ title }}</el-breadcrumb-item>
            </el-breadcrumb>
        </comp-title>

        <div class="trade-record">
            <!-- 查询条件start -->
            <el-row class="fund-filter">
                <el-col :span="24" class="btn-fund">
                    时间周期：
                    <el-radio-group v-model="tradeTime" size="mini">
                        <el-radio-button v-for="type in tradeTimeArr" :key="type.val" :label="type.val">
                            {{ type.text }}
                        </el-radio-button>
                    </el-radio-group>
                    <div v-if="tradeTime==='6'" class="custom-time">
                        <date-picker :date="dateSet" v-on:date-get="dateInterval"/>
                        <el-button size="small" round v-on:click.prevent="searchFund">
                            查询
                        </el-button>
                    </div>
                </el-col>
                <el-col :span="24" class="btn-search">
                    查询条件：
                    <el-input
                        v-model="searchText"
                        placeholder="请输入基金名称或基金代码"
                        class="input-search"
                        size="small"
                    />
                    <el-button
                        class="btn-search-icon"
                        icon="el-icon-search"
                        type="primary"
                        size="small"
                        v-on:click="searchFund"
                    />
                </el-col>
            </el-row>
            <!-- 查询条件end -->

            <!-- 表格start -->
            <el-table
                :data="fund"
                style="width: 100%"
                class="tab-list-tit"
                :row-key="getRowKeys"
            >
                <el-table-column
                    prop="taserialno"
                    label="TA确认流水号"
                    align="center"
                />
                <el-table-column
                    prop="cfmdate"
                    label="分红确认日期"
                    align="center"
                    :formatter="formatterDate"
                />
                <el-table-column
                    prop="fundname"
                    label="基金名称"
                    align="center"
                    :formatter="formatterName"
                >
                    <template slot-scope="scope">
                        <span class="like-a" v-on:click.prevent="gotoDetail(scope.row)">{{ scope.row.fundname }}</span>
                    </template>
                </el-table-column>
                <el-table-column
                    prop="confirmedvol"
                    label="确认份额"
                    align="center"
                    :formatter="formatterCfmAmount"
                >
                </el-table-column>
                <el-table-column
                    prop="confirmedamount"
                    label="确认金额"
                    align="center"
                    :formatter="formatterCfmAmount">
                </el-table-column>
                <el-table-column label="详情" align="center">
                    <template slot-scope="scope">
                        <span class="like-a" v-on:click.prevent="fundDetail=scope.row;detailVisible=true">详情</span>
                    </template>
                </el-table-column>
            </el-table>
            <!-- 表格end -->

            <!-- 分页start -->
            <el-row v-if="allPage > pagecount" class="page-box">
                <el-pagination
                    :page-size="Number(pagecount)"
                    :current-page.sync="curPage"
                    background
                    layout="prev, pager, next"
                    :total="Number(allPage)"
                    v-on:current-change="pageRefresh"
                />
            </el-row>
            <!-- 分页end -->
        </div>

        <!--详情弹框start -->
        <el-dialog title="详细信息" :visible.sync="detailVisible" class="prop info-tips" width="1000px">
            <div class="investor-tips">
                <div class="prompt-info">
                    <el-form
                        label-position="left"
                        inline
                        class="demo-table-expand"
                        style="max-height: 220px;"
                    >
                        <el-form-item label="TA确认流水号">
                            <span>{{ fundDetail.taserialno ? fundDetail.taserialno : '--' }}</span>
                        </el-form-item>
                        <el-form-item label="分红确认日期">
                            <span>
                                {{
                                    fundDetail.cfmdate ? $util.fmtDate(fundDetail.cfmdate) : '--'
                                }}
                            </span>
                        </el-form-item>
                        <el-form-item label="基金名称">
                            <span>
                                {{ fundDetail.fundname ? fundDetail.fundname : '--' }}
                            </span>
                        </el-form-item>
                        <el-form-item label="确认份额">
                            <span>
                                {{ $util.fmtNum(fundDetail.confirmedvol) }}
                            </span>
                        </el-form-item>
                        <el-form-item label="确认金额">
                            <span>
                                {{ $util.fmtNum(fundDetail.confirmedamount) }}
                            </span>
                        </el-form-item>
                        <el-form-item label="基金账号">
                            <span>
                                {{ fundDetail.taaccountid ? fundDetail.taaccountid : '--' }}
                            </span>
                        </el-form-item>
                        <el-form-item label="业务类型">
                            <span>{{ fundDetail.businesscode?$cache.getDict('130010', fundDetail.businesscode) : '--' }}</span>
                        </el-form-item>
                        <el-form-item label="份额净值">
                            <span>{{ $util.fmtNum(fundDetail.nav, 4) }}</span>
                        </el-form-item>
                        <el-form-item label="确认信息">
                            <span>
                                {{ fundDetail.returnmsg ? fundDetail.returnmsg : '--' }}
                            </span>
                        </el-form-item>
                        <el-form-item label="分红方式">
                            <span>{{
                                    fundDetail.defdividendmethod ? $cache.getDict('110001', fundDetail.defdividendmethod) : '--'
                                }}</span>
                        </el-form-item>
                    </el-form>
                </div>
            </div>
        </el-dialog>
        <!--详情弹框end -->
    </div>
</template>
<script>
import format from "date-fns/format";
import mixin from "@/assets/js/mixin";
import datePicker from "@/components/form/datePicker";

export default {
    name: "DividendInfo",
    components: {
        datePicker
    },
    mixins: [mixin],
    data() {
        return {
            curPage: 1,
            tradeTime: "", // 已选择的时间周期
            searchText: "",// 基金名称或基金代码
            fund: [],// 表格数据
            endDate: "",// 结束时间
            beginDate: "",// 开始时间
            nowDate: "", // 当前时间
            pagecount: "",// 页码大小
            pageoffset: "0",
            allPage: "0", // 分页总数量
            queryFind: null,// 限制前后两次请求间隔时间的定时器
            query: null,// 限制规定时间内请求次数的定时器
            index: 0,// 连续点击次数
            tradeTimeArr: [// 时间周期
                {val: "1", text: "近7天"},
                {val: "2", text: "近一个月"},
                {val: "3", text: "近三个月"},
                {val: "4", text: "近半年"},
                {val: "5", text: "近一年"},
                {val: "6", text: "自定义"}
            ],
            fundDetail: {},// 详情弹框数据
            detailVisible: false,// 是否展示详情弹框
            dateSet: {type: "2", min: "1990-01-01", size: "mini"},// 时间选择器组件属性
        };
    },

    watch: {
        // 已选择的时间周期
        tradeTime(val, old) {
            this.endDate = this.nowDate;
            const _x = new Date(this.$util.fmtDate(this.nowDate)).getTime();
            if (val === "1") {
                this.beginDate = format(_x - 7 * 24 * 3600 * 1000, "YYYYMMDD");
            } else if (val === "2") {
                this.beginDate = this.$util.getBeginDate(this.nowDate, 1);
            } else if (val === "3") {
                this.beginDate = this.$util.getBeginDate(this.nowDate, 3);
            } else if (val === "4") {
                this.beginDate = this.$util.getBeginDate(this.nowDate, 6);
            } else if (val === "5") {
                this.beginDate = this.$util.getBeginDate(this.nowDate, 1, true);
            } else if (val === "6") {
                this.fund = [];
                this.allPage = 0;
                this.endDate = "";
                this.beginDate = "";
                return;
            }
            this.pageoffset = "0";
            this.doAction();
        }
    },

    created() {
        this.nowDate = format(new Date(), "YYYYMMDD");
        // 初始化页码
        this.pagecount = this.$util.getConfig().const.PAGE_SIZE;
        this.dateSet.max = this.$util.fmtDate(this.nowDate);
        this.tradeTime = "1";
    },

    methods: {
        // 跳转路由到基金详情
        gotoDetail(val) {
            let params = {
                secondtype: val.fundcode,
                etfflag: val.etfflag
            };
            if (val.fundtype === "4") {
                params["watchcontrol"] = "1";//专户可查公告
            }
            this.$util.toCompPage("/fund", params);
        },

        // 格式化日期
        formatterDate(row, column, value) {
            return this.$util.fmtDate(value);
        },

        // 格式化基金名称
        formatterName(row, column, value) {
            if (row.businesscode === "36" || row.businesscode === "D2" || row.businesscode === "69" || (row.businesscode === "24" && (row.businesskind === "2" || row.businesskind === "6"))) {
                return row.targetfundname + "(" + (row.targetfundcode === "515981" ? "515980" : row.targetfundcode) + ")";
            }
            return row.fundname + "(" + row.fundcode + ")";
        },

        // 格式化金额
        formatterCfmAmount(row, column, value) {
            return this.$util.fmtNum(value);
        },

        // 指定每行row-key
        getRowKeys(row) {
            return row.appsheetserialno;
        },

        // 获取用户选中时间区间
        dateInterval(val) {
            // convert "YYYY-MM-DD" to "YYYYMMDD"
            this.beginDate = this.$util.isEmpty(val.beginDate) ? "" : val.beginDate.replace(/-/g, "");
            this.endDate = this.$util.isEmpty(val.endDate) ? "" : val.endDate.replace(/-/g, "");
        },

        // 改变分页
        pageRefresh(val) {
            this.pageoffset = val - 1;
            this.doAction();
        },

        // 搜索基金
        searchFund() {
            if (this.$util.isEmpty(this.beginDate) || this.$util.isEmpty(this.endDate)) {
                let _m = "请输入完整的日期范围";
                this.$alert(_m, "日期提示");
                this.fund = [];
                this.allPage = 0;
                return;
            }
            this.doAction(this.searchText);
        },

        // 获取基金信息
        getFund(val, cb) {
            const _x = {
                begindate: this.beginDate,
                enddate: this.endDate,
                sourceflag: this.fundFrom,
                keyword: val || this.searchText,
                pagecount: cb ? "1000" : this.pagecount,
                pageoffset: ((val ? "0" : this.pageoffset) * this.pagecount).toString()
            };
            this.$util.request("acct/dividend/info", _x, "GET", false).then(res => {
                if (res.data) {
                    if (!cb) {
                        this.allPage = res.alllength;
                        this.fund = this.filterSame(res.data[0]);
                    } else {
                        cb.call(this, res.data);
                    }
                }
            });
        },

        // 筛选列表数据
        filterSame(data) {
            if (data.length === 0) {
                return [];
            }
            let records = [data[0]];
            let skip = "cfmevol";//确认份额，120,130两笔记录返回数据只有这个字段不同
            data.forEach(rs => {//认购记录有两比记录120认购申请确认、认购结果确认，有认购结果只显示认购结果一条
                let isSame = true;
                records.forEach(rs1 => {
                    isSame = true;
                    for (let key in rs) {
                        if (key === skip) continue;
                        if (rs[key] !== rs1[key]) {
                            isSame = false;
                            break;
                        }
                    }
                });
                if (!isSame) {
                    records.push(rs);
                } else {
                    this.allPage -= 1;
                }
            });
            return records;
        },

        // 连续请求次数限制
        actionLimit() {
            const _this = this;
            if (this.query !== null) {
                clearTimeout(this.query);
                this.index++;
            }
            this.query = setTimeout(() => {
                _this.index = 0;
                clearTimeout(this.query);
            }, 2000);
            if (this.index > 3) {
                this.$alert("您请求太频繁，请等待一会！", "访问提示");
                this.query = setTimeout(() => {
                    _this.index = 0;
                    clearTimeout(this.query);
                }, 500);
            }
            return true;
        },

        // 对基金频繁查询请求做处理
        doAction(val, cb) {
            // 连续请求次数限制
            this.actionLimit();
            this.fund = [];
            this.allPage = 0;
            const _this = this;
            if (cb) {
                val = this.$util.filterCode(val);
                this.searchText = val;
                if (val.length < 1) {
                    cb.call(this, []);
                    return false;
                }
            }
            clearTimeout(this.queryFind);
            this.queryFind = setTimeout(function () {
                _this.getFund(val, cb);
            }, 100);
        }
    }
};
</script>
<style lang="scss">
@import "../../assets/css/varibles";

.bizcomp-trade-record {
    /*自定义时间控件*/
    .custom-time {
        display: inline-block;
        vertical-align: middle;

        .comp-date-picker {
            width: auto;
        }

        .el-button {
            min-width: 100px;
            border-color: $color-b;
            color: $color-b;
            background-color: $bg5;
            padding: 8px 15px;
            margin-left: 13px;
        }
    }

    .info-tips {
        .two-cols-form .el-form-item__content {
            .el-input {
                width: 70%;
            }
        }

        .prompt-info {
            .el-icon-warning {
                color: $color-a;
                margin-right: 8px;
                font-size: $f24;
                vertical-align: middle;
            }

            span {
                vertical-align: middle;
            }
        }
    }
}
</style>
